import { render } from "./ProductsDetailDepthItem.vue?vue&type=template&id=22625a8a&ts=true"
import script from "./ProductsDetailDepthItem.vue?vue&type=script&lang=ts"
export * from "./ProductsDetailDepthItem.vue?vue&type=script&lang=ts"

import "./ProductsDetailDepthItem.vue?vue&type=style&index=0&id=22625a8a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__